<template>
  <div class="pendencies-main-view width-responsiveness">
    <sub-header
      title="Pendências"
      updated-time
      icon-path="/static/images/icon-dashboard-attention.svg"
      back-router-name="Dashboard"
    />

    <pendencies-filter />

    <div class="container-orderBy">
      <div class="combo-box">
        <combo-box
          id="sort-pendencies"
          :options="options"
          option-label="label"
          :disabled="isPendenciesLoading"
          placeholder="Ordernar por: Selecione..."
          :field.sync="orderBy"
        />
      </div>
    </div>

    <tabs
      class="mt-6 mb-2"
      with-border
      :tabs="tabs"
      :tab-selected="pendenciesCurrentTab"
      @tabClicked="changeTab"
    />

    <div class="pendencies-main-view__middle-side">
      <pendencies-data-table />
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeaderV2'
import Tabs from '../common/Tabs.vue'
import PendenciesFilter from './PendenciesFilter.vue'
import PendenciesDataTable from '@/components/Pendencies/PendenciesDataTable'
import ComboBox from '../common/ComboBox'
import { mapGetters, mapActions } from 'vuex'
import {
  PENDENCIES_ORDER_BY_PATIENT_NAME,
  PENDENCIES_ORDER_BY_STATUS,
  PENDENCIES_ORDER_BY_SEND_DATE
} from '@/enums'

export default {
  name: 'PendenciesMainView',
  components: {
    SubHeader,
    Tabs,
    PendenciesFilter,
    PendenciesDataTable,
    ComboBox
  },
  data() {
    return {
      options: [
        { value: PENDENCIES_ORDER_BY_PATIENT_NAME, label: 'Nome' },
        { value: PENDENCIES_ORDER_BY_STATUS, label: 'Status' },
        { value: PENDENCIES_ORDER_BY_SEND_DATE, label: 'Data da Pendência' }
      ],
      orderBy: null
    }
  },
  computed: {
    ...mapGetters([
      'pendenciesParams',
      'isPendenciesLoading',
      'pendenciesCurrentTab',
      'totalPendenciesQuantity',
      'totalPendenciesPendente',
      'totalPendenciesRealizado'
    ]),
    tabs() {
      return [
        { name: 'Todos', key: 'TODOS', total: this.totalPendenciesQuantity ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
        { name: 'Pendentes', key: 'P', total: this.totalPendenciesPendente ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
        { name: 'Respondidas', key: 'R', total: this.totalPendenciesRealizado ?? 0, tooltip: 'Clique aqui para filtrar o Status' }
      ]
    }
  },
  watch: {
    orderBy(newValue) {
      if (newValue) {
        const updatedFilters = {
          ...this.pendenciesParams,
          orderBy: newValue.value
        }

        this.setWaitingPendenciesLoadingStatus()
        this.selectPendenciesFilter(updatedFilters)
        this.fetchPendenciesForSubmit()
        this.getAllTotalPendenciesQuantity()
      }
    }
  },
  beforeDestroy() {
    this.resetStore()
  },
  methods: {
    ...mapActions([
      'selectPendenciesFilter',
      'fetchPendenciesForSubmit',
      'getAllTotalPendenciesQuantity',
      'setCurrentTabPendencies',
      'resetStore',
      'setWaitingPendenciesLoadingStatus'
    ]),

    async changeTab(index) {
      const tabKey = this.tabs[index].key
      const statusParsed = tabKey === 'TODOS' ? [] : [tabKey]

      this.setCurrentTabPendencies(index)

      const updatedFilters = {
        ...this.pendenciesParams,
        status: statusParsed
      }

      this.selectPendenciesFilter(updatedFilters)
      await this.fetchPendenciesForSubmit()
      await this.getAllTotalPendenciesQuantity()
    }
  },

}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.pendencies-main-view {
  height: 100vh;
  padding-top: $mainHeaderHeight !important;
  margin-top: 85px;

  .container-orderBy {
    width: 100%;
    display: flex;
    position: absolute;
    margin-top: 25px;
    padding-right: 130px;
    justify-content: end;

    .combo-box {
      width: 280px;

      #sort-pendencies {
        width: 100%;
        background: rgba(83, 83, 83, 0.04);
        padding: 4px 8px;
        cursor: pointer;

        input {
          font-size: 14px;
          background-color: none;
        }

        .selected-tag {
          text-transform: inherit;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
